// TODO: remove class since we have 1 version of recommended service now
import { PlatformLocation } from '@angular/common';
import { Inject, Injectable } from '@angular/core';

import { OfficeHomePageErrorHandler } from '../error-handler/error-handler.service';
import { InstrumentationService } from '../shared/instrumentation/instrumentation.service';
import { InstrumentedHttp } from '../shared/instrumentation/instrumented-http.service';
import { MruConfigService } from '../shared/mru/mru-config.service';
import { AadAppId, AAD_APP_ID } from '../shared/services/aad-app-id.injection-token';
import { AccessTokenService } from '../shared/services/access-token.service';
import { OfficeHomeApiConfigService } from '../shared/services/officehome-api-config.service';
import { SchedulerService } from '../shared/services/scheduler.service';
import { UpdateContentService } from '../shared/services/update-content.service';
import { WindowService } from '../shared/services/window.service';
import { CapabilitiesService } from '../shared/shared-context/capabilities.service';
import { ClientStartupConfigService } from '../shared/shared-context/client-startup-config.service';
import { ContextService } from '../shared/shared-context/context.service';
import { RecommendedDataService } from './recommended-data.service';
import { RecommendedServiceV1 } from './recommended-v1.service';

@Injectable({
    providedIn: 'root'
})
export class RecommendedDataServiceFactory {
    private readonly recommendedDataService: RecommendedDataService;

    constructor(
        accessTokenService: AccessTokenService,
        capabilitiesService: CapabilitiesService,
        contextService: ContextService,
        instrumentationService: InstrumentationService,
        instrumentedHttp: InstrumentedHttp,
        mruConfigService: MruConfigService,
        officeHomeApiConfigService: OfficeHomeApiConfigService,
        platformLocation: PlatformLocation,
        globalErrorHandler: OfficeHomePageErrorHandler,
        startupConfigService: ClientStartupConfigService,
        updateContentService: UpdateContentService,
        scheduler: SchedulerService,
        windowService: WindowService,
        @Inject(AAD_APP_ID) aadAppId: AadAppId
    ) {
        this.recommendedDataService = new RecommendedServiceV1(accessTokenService, capabilitiesService, contextService, instrumentationService, instrumentedHttp, mruConfigService, officeHomeApiConfigService, platformLocation, globalErrorHandler, startupConfigService, updateContentService, scheduler, windowService, aadAppId);
    }

    public getRecommendedService(): RecommendedDataService {
        return this.recommendedDataService;
    }
}
